import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://manaraschool.org';

export default function MetaTags({ title, seo }) {
  const { t } = useTranslation(['HomePage']);
  const location = useLocation();

  const path = location.pathname.replace(/\/$/, '') || '/';
  const canonicalUrl = `${SITE_URL}${path}`;

  const currentLocale = path.startsWith('/ar') ? 'ar' : 'en';
  const otherLocale = currentLocale === 'ar' ? 'en' : 'ar';
  const alternatePath = path.replace(/^\/(en|ar)/, `/${otherLocale}`);
  const alternateUrl = `${SITE_URL}${alternatePath}`;
  const defaultUrl = `${SITE_URL}${path.replace(/^\/(en|ar)/, '/en')}`;

  const pageTitle = title
    ? `${t('manaraSchool')} | ${title}`
    : `${t('manaraSchool')}`;

  const metaTagsJSX = seo?.map(({ id, name, content }) => (
    <meta key={`meta-${id}-${name}`} name={name} content={content} />
  ));

  return (
    <Helmet>
      <html lang={currentLocale} dir={currentLocale === 'ar' ? 'rtl' : 'ltr'} />
      <title>{pageTitle}</title>
      {metaTagsJSX}

      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={t('manaraSchool')} />

      <link rel="alternate" hrefLang={currentLocale} href={canonicalUrl} />
      <link rel="alternate" hrefLang={otherLocale} href={alternateUrl} />
      <link rel="alternate" hrefLang="x-default" href={defaultUrl} />
    </Helmet>
  );
}
